
const live = true;

function tentwentyfive() {
  return "10px 25px";
}
function tenzero() {
  return "10px 0";
}
function tenauto() {
  return "10px auto";
}

export function getTime(startTime: Date) {
  const date = new Date();
  const difference = Math.abs(date.getTime() - startTime.getTime());
  const hours = Math.floor(difference / 3600000);
  const minutes = Math.floor((difference % 3600000) / 60000);
  const seconds = Math.floor((difference % 60000) / 1000);

  const timeTaken = hours + " h: " + minutes + " m: " + seconds + " s";
  return timeTaken;
}

function urlbase() {
  console.log("window._env_: ", window._env_);
  if (window._env_?.APP_ENV != "prod" && window._env_?.APP_ENV != "stage") {
    console.log("local: ", process.env.REACT_APP_BASE_URL);
      return process.env.REACT_APP_BASE_URL;
  } else {
    console.log("live: ", process.env.REACT_APP_BASE_URL);
      return window._env_?.REACT_APP_BASE_URL
  }
}

function headers() {
  return {
    "Content-Type": "application/json",
  };
}

function NumberToMonth(month) {
  switch (month) {
    case 0:
      return "January";
    case 1:
      return "Februrary";
    case 2:
      return "March";
    case 3:
      return "April";
    case 4:
      return "May";
    case 5:
      return "June";
    case 6:
      return "July";
    case 7:
      return "August";
    case 8:
      return "September";
    case 9:
      return "October";
    case 10:
      return "November";
    case 11:
      return "December";
  }
}

function MonthToNumber(month) {
  switch (month) {
    case "January":
      return 0;
    case "Februrary":
      return 1;
    case "March":
      return 2;
    case "April":
      return 3;
    case "May":
      return 4;
    case "June":
      return 5;
    case "July":
      return 6;
    case "August":
      return 7;
    case "September":
      return 8;
    case "October":
      return 9;
    case "November":
      return 10;
    case "December":
      return 11;
  }
}

function LetterToNumber(index) {
  switch (index) {
    case "A":
      return 0;
    case "B":
      return 1;
    case "C":
      return 2;
    case "D":
      return 3;
    case "E":
      return 4;
  }
}

function NumberToLetter(index) {
  switch (index) {
    case 0:
      return "A";
    case 1:
      return "B";
    case 2:
      return "C";
    case 3:
      return "D";
    case 4:
      return "E";
    case 5:
      return "F";
    case 6:
      return "G";
    case 7:
      return "H";
    case 8:
      return "I";
    case 9:
      return "J";
    case 10:
      return "K";
  }
}

function fixOptions(text, latex) {
  // Import the centralized formatLatexText utility
  const { formatLatexText } = require('../utils/formatLaTex');
  
  // Handle edge cases
  if (!latex || latex.length === 1) return latex;

  // Use formatLatexText for consistent LaTeX processing
  let formatted = formatLatexText(latex);

  // Additional cleanup for options that might need text prepended
  if (text && text.trim() !== "") {
    // If formatted is wrapped in delimiters, insert text after opening delimiter
    if (formatted.startsWith("$$") && formatted.endsWith("$$")) {
      const inner = formatted.substring(2, formatted.length - 2);
      formatted = `$$\\text{${text}}\\hspace{1mm}${inner}$$`;
    } else if (formatted.startsWith("$") && formatted.endsWith("$")) {
      const inner = formatted.substring(1, formatted.length - 1);
      formatted = `$\\text{${text}}\\hspace{1mm}${inner}$`;
    } else {
      formatted = `$\\text{${text}}\\hspace{1mm}${formatted}$`;
    }
  }

  return formatted;
}

function fixMarginQuestionButtons(numberOfButtons) {
  switch (numberOfButtons) {
    case 2:
      return "10px 84px";
    case 3:
      return "10px 56px"; //These values were guestimated but not tested, because I'd rather not leave it blank /// TODO: Fill in this constant
    case 4:
      return "10px 10px";
    case 5:
      return "10px 0px";
  }
}

function correctColor() {
  return "rgba(146,236,141,0.5)";
}

function wrongColor() {
  return "rgba(241,69,69,0.5)";
}

function missingColor() {
  return "#e78890";
}

export {
  tentwentyfive,
  tenzero,
  tenauto,
  urlbase,
  headers,
  MonthToNumber,
  NumberToMonth,
  LetterToNumber,
  NumberToLetter,
  fixOptions,
  fixMarginQuestionButtons,
  correctColor,
  wrongColor,
  missingColor,
};
